export default "__VITE_ASSET__RJIwN$I6__"